import Tabs from "@/v2-backoffice-client/components/tabs"
import { useLicenseAccountsQuery } from "@/v2-backoffice-client/license/account/license.account.query"
import { LICENSING_VIEW_BILLING_ACCOUNTS } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Billing Accounts tab trigger. Owns its own read of
// the accounts query — Apollo dedupes it against the board's — so the count
// stays live no matter which tab is open. Attention states (unmatched
// accounts) live in the board's own filter chips, not up here.
function LicenseAccountTabTrigger() {
  const { data, loading } = useLicenseAccountsQuery()
  const accountCount = (data?.getBillingAccounts ?? []).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_BILLING_ACCOUNTS}
      iconSrc="bank"
      isLoading={loading}
      count={accountCount}
    >
      Billing Accounts
    </Tabs.Trigger>
  )
}

export default LicenseAccountTabTrigger
